// src/services/Http.js
import axios from 'axios';
import { BASEURL } from './config/apiConfig';

class HttpService {
  constructor() {
    this.self = this;

    this.client = axios.create({
      baseURL: BASEURL,
    });
  }

  _appendToken(options) {
    if (!options) {
      return { headers: { Authorization: this.getBearer() } };
    }

    if (!options.headers) {
      options.headers = { Authorization: this.getBearer() };
    } else {
      options.headers.Authorization = this.getBearer();
    }
    return options;
  }

  get(url, options) {
    return this.client.get(url, this._appendToken(options));
  }

  post(url, data, options) {
    return this.client.post(url, data, this._appendToken(options));
  }

  put(url, data, options) {
    return this.client.put(url, data, this._appendToken(options));
  }

  patch(url, data, options) {
    return this.client.patch(url, data, this._appendToken(options));
  }

  delete(url, options) {
    return this.client.delete(url, this._appendToken(options));
  }

  authorize(credentials) {
    return this.post(
      '/api/authorization/token',
      this.objectToFormUrlEncodedData(credentials),
    ).then(this.authorizationCompleted);
  }

  checkBearer() {
    return this.get('/api/me/authorization/state');
  }

  authorizationCompleted(response) {
    window.localStorage.setItem('bearer-jwt', response.headers.authorization);
  }

  objectToFormUrlEncodedData(details) {
    const formBody = Object.keys(details).map((key) => {
      const encodedKey = encodeURIComponent(key);
      const encodedValue = encodeURIComponent(details[key]);
      return `${encodedKey}=${encodedValue}`;
    });

    return formBody.join('&');
  }

  getBearer() {
    return window.localStorage.getItem('bearer-jwt');
  }

  setBearer(bearer) {
    window.localStorage.setItem('bearer-jwt', bearer);
  }

  removeBearer() {
    delete this.client.defaults.headers.common?.Authorization;
    window.localStorage.removeItem('bearer-jwt');
  }
}

export default new HttpService();
